import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TenLoading from '../loading';
import domHelper from '../utils/dom-helper';
import classNames from 'classnames';
export default class ReactComponent extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    empty: PropTypes.bool,
    emptyTip: PropTypes.string,
    multiple: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    showRadio: PropTypes.bool,
  };
  static defaultProps = {
    emptyTip: '暂无数据',
  };
  static childContextTypes = {
    tenOptions: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      focusIndex: -1,
      focused: false,
      options: [],
    };
  }
  allOptions = [];
  getChildContext() {
    return {
      tenOptions: this,
    };
  }

  componentDidMount() {
    this.allOptions.push(this);
  }

  // componentDidMount() {
  //   document.addEventListener('click', this.onClickOutside);
  //   // this.$on('focusOptionChange', this.onFocusOptionChange);
  // }

  componentWillUnmount() {
    this.allOptions = this.allOptions.filter((options) => options !== this);
    this.blur();
    document.removeEventListener('click', this.onClickOutside);
  }

  addOption(option) {
    const { options } = this.state;
    const newOptionIndex = typeof option.optionIndex === 'undefined' ? Infinity : option.optionIndex;
    let i;

    for (i = 0; i < options.length; i++) {
      const optionIndex = typeof options[i].optionIndex === 'undefined' ? -Infinity : options[i].optionIndex;

      if (newOptionIndex < optionIndex) {
        i += 1;
        break;
      }
    }
    this.setState({
      options: options.splice(i, 0, option),
    });
  }

  removeOption(option) {
    this.setState({
      options: this.state.options.filter((item) => item !== option),
    });
  }

  focus(index) {
    if (!this.state.focused) {
      this.allOptions.forEach((options) => {
        if (options !== this) {
          options.blur();
        }
      });
      this.setState({
        focused: true,
      });
      this.bindKeyEvent();

      if (typeof index !== 'undefined') {
        this.focusOption(index);
      }
    }
  }

  blur() {
    if (this.state.focused) {
      this.setState({
        focused: false,
      });
      this.unbindKeyEvent();
    }
  }

  focusOption(index) {
    const { options } = this.state;
    options.forEach((option, oIndex) => {
      if (oIndex !== index) {
        option.blur();
      }
    });
    if (options[index]) {
      this.setState({
        focusIndex: index,
      });
      options[index].focus();
      const { optionsElem } = this.$refs;
      const optionElem = options[index].$el;
      const optionHeight = optionElem.offsetHeight;
      const optionOffsetTop = optionElem.offsetTop;
      const optionsScrollTop = optionsElem.scrollTop;
      const optionsHeight = optionsElem.clientHeight;

      if (optionOffsetTop < optionsScrollTop) {
        optionsElem.scrollTop = optionOffsetTop;
      } else if (optionOffsetTop + optionHeight > optionsScrollTop + optionsHeight) {
        optionsElem.scrollTop = optionOffsetTop + optionHeight - optionsHeight;
      }
    }
  }

  bindKeyEvent() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  unbindKeyEvent() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onClickOutside(e) {
    if (!domHelper.contains(this.$refs.optionsElem, e.target)) {
      this.blur();
    }
  }

  onKeyDown = (e) => {
    const { options } = this.state;
    const total = options.length;
    const { keyCode } = e;
    let { focusIndex } = this;

    switch (keyCode) {
      case 13:
      case 37:
      case 39:
        // e.preventDefault();
        if (focusIndex <= total - 1 && focusIndex >= 0) {
          options[focusIndex].onKeyDown(e);
        }

        break;

      case 38:
        // up
        focusIndex = focusIndex <= 0 ? total - 1 : focusIndex - 1;
        this.focusOption(focusIndex);
        e.preventDefault();
        break;

      case 40:
        // down
        focusIndex = focusIndex >= total - 1 ? 0 : focusIndex + 1;
        this.focusOption(focusIndex);
        e.preventDefault();
        break;

      default:
        break;
    }
  };

  onClick = () => {
    this.focus();
  };

  onFocusOptionChange(option) {
    const { options } = this.state;
    const index = options.indexOf(option);

    if (index > -1) {
      this.focusOption(index);
    }
  }

  render() {
    const contentClass = classNames([
      'ten-options',
      {
        'ten-options--empty': this.props.empty,
        'ten-options--loading': this.props.loading,
      },
    ]);
    const { loading, empty, emptyTip, children } = this.props;
    return (
      <div onClick={this.onClick} className={contentClass}>
        {!loading && empty ? <div className="ten-options__empty">{emptyTip}</div> : children}
        {loading && <TenLoading type="block" className="ten-options__loading"></TenLoading>}
      </div>
    );
  }
}
